<p-fieldset legend="Lehre/Berufsausbildung">
  <div class="flex flex-col gap-4 pt-2">
    <p-fluid>
      <p-floatlabel variant="on">
        <input id="Unternehmen" type="text" pInputText appTrTrim [formControl]="lehreFormGroup!.controls.unternehmen" />
        <label for="Unternehmen">Unternehmen*</label>
      </p-floatlabel>
    </p-fluid>

    <p-floatlabel variant="on">
      <p-select inputId="branche" [formControl]="lehreFormGroup!.controls.branche" [options]="branches" dropdownIcon="pi-angle-down" fluid="true" />
      <label for="branche">Branche</label>
    </p-floatlabel>

    <p-fluid>
      <p-floatlabel variant="on">
        <input id="(Angestrebter) Abschluss" type="text" pInputText appTrTrim [formControl]="lehreFormGroup!.controls.abschluss" />
        <label for="(Angestrebter) Abschluss">(Angestrebter) Abschluss</label>
      </p-floatlabel>
    </p-fluid>

    <p-fluid>
      <app-date-range [vonDate]="lehreFormGroup!.controls.von" [bisDate]="lehreFormGroup!.controls.bis"></app-date-range>
    </p-fluid>
  </div>
  <div class="flex flex-row justify-end items-end pt-2">
    <p-button severity="danger" outlined type="button" (click)="remove.emit()" icon="pi pi-trash" label="Löschen"></p-button>
  </div>
</p-fieldset>
